import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';

export default class extends Controller {
  static targets = ['countdown'];
  static values = {
    endsAt: Number,
    unit: { type: String, default: 'hours' },
    format: { type: String, default: 'h : %Mm : %Ss' },
    finishedText: { type: String, default: '00h : 00m : 00s' },
  };

  disconnect() {
    $(this.countdownTarget).countdown('remove');
  }

  connect() {
    $(this.countdownTarget)
      .countdown(this.endsAtValue * 1000)
      .on('update.countdown', (event) => {
        const prefix = this.unitValue === 'days'
          ? event.offset.totalDays
          : event.offset.totalHours;
        this.countdownTarget.textContent = prefix + event.strftime(this.formatValue);
      })
      .on('finish.countdown', () => {
        this.countdownTarget.textContent = this.finishedTextValue;
      });
  }
}